import { motion, useAnimation } from 'framer-motion'
import NumberAnimate from '../../NumberAnimate'
import SVGJSContainer, { pathDraw120 } from '../../../utils/SVGJSContainer'

function Immeubles2() {
	const controls = useAnimation()
	return (
		<SVGJSContainer key="Immeubles2" controls={controls}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="1369"
				height="194"
				viewBox="0 0 1369 194"
			>
				<defs>
					<linearGradient
						id="linear-gradientImmeubles2"
						x2="0.979"
						y1="0.642"
						y2="0.5"
						gradientUnits="objectBoundingBox"
					>
						<stop offset="0" stopColor="#98b27f"></stop>
						<stop offset="1" stopColor="#e1ea65"></stop>
					</linearGradient>
				</defs>
				<g data-name="Groupe 2561" transform="translate(-173 -1751)">
					<text
						data-name="1 387"
						fontFamily="AcuminPro-Bold, Acumin Pro"
						fontSize="180"
						fontWeight="700"
						fill="#82a568"
						letterSpacing="-.03em"
						transform="translate(1153 1942)"
					>
						<tspan x="0" y="0">
							<NumberAnimate tspan nb={1130} duration={1.5} delay={0.5} />
						</tspan>
					</text>
					<motion.path
						fill="none"
						stroke="#E1EA65"
						strokeMiterlimit="10"
						strokeWidth="194"
						d="M0 0L906.128 0"
						data-name="Ligne1691"
						transform="translate(168.936 1817.841)"
						variants={pathDraw120}
						initial="hidden"
						animate={controls}
					></motion.path>
					<motion.path
						fill="none"
						stroke="#82a568"
						strokeMiterlimit="10"
						strokeWidth="194"
						d="M0 0L906.128 0"
						data-name="Ligne14691"
						transform="translate(168.936 1947.841)"
						variants={pathDraw120}
						initial="hidden"
						animate={controls}
					></motion.path>
				</g>
			</svg>
		</SVGJSContainer>
	)
}

export default Immeubles2
